module.exports = __webpack_public_path__ + "static/logo-wurth-cd1bbbb8bed651bd00a097f599641a1c.png";